import React, { useState } from 'react'
import { InfoWindow, Marker, MarkerClusterer } from '@react-google-maps/api'

const noOp = () => {}

export const MapMarkers = ({ workshops, options }) => {
  const [showInfoFor, setShowInfoFor] = useState()

  return (
    <MarkerClusterer options={options}>
      {(clusterer) =>
        workshops
          ? workshops.map((marker, index) => (
              <React.Fragment key={index}>
                <Marker
                  key={`market-${index}`}
                  position={marker}
                  clusterer={clusterer}
                  onClick={() => setShowInfoFor(index)}
                />

                {showInfoFor === index && (
                  <InfoWindow
                    key={`info-${index}`}
                    onLoad={noOp}
                    onCloseClick={() => setShowInfoFor(null)}
                    position={marker}
                  >
                    <React.Fragment>
                      <h4 style={{ marginTop: 0 }}>{marker.name}</h4>
                      <p>
                        {marker.street}
                        <br />
                        {marker.zip} {marker.city}
                      </p>
                      {marker.phone && <p>Tlf: {marker.phone}</p>}
                    </React.Fragment>
                  </InfoWindow>
                )}
              </React.Fragment>
            ))
          : null
      }
    </MarkerClusterer>
  )
}
